import React from "react";
import './homecontent.css';
import Hero from "../Hero/Hero";
import { FeaturesSection } from "../FeatureSection/FeatureSection";
import CallToAction from "../CallToAction/CallToAction";

const HomeContent: React.FC = () => {
    return (
        <main>
            <Hero></Hero>
            <FeaturesSection features={[{icon:"https://img.freepik.com/free-vector/webpage-template-with-code_24908-78070.jpg?t=st=1724560273~exp=1724563873~hmac=e24dd41658fcf3045f81578b99e9b0db68f2f99870faec4b9a134291592a8512&w=1380",title:"Web Development",description:"We craft custom, responsive websites that elevate your brand and drive results. From design to deployment, our web development services focus on creating seamless user experiences and scalable solutions that grow with your business."},{icon:"https://img.freepik.com/free-vector/hand-drawn-flat-design-api-illustration_23-2149379500.jpg?t=st=1724560485~exp=1724564085~hmac=4e16812225c1c45fa10a34f8d74574581af631fb7069ef9894499ec9efee8549&w=1380",title:"Custom Software",description:"Whether it be simple scripts or custom apps integrated with your current system, Alvero software strives to create the best software for your companies needs."}]}></FeaturesSection>
            <CallToAction></CallToAction>
        </main>
    );
};

export default HomeContent;